module.exports = __webpack_public_path__ + "img/63.2.TN.e880b115.png";